import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { createOneOffCheckoutSession } from "../services/billing.service";

// Replace with your actual Publishable Key from Stripe Dashboard
const stripePromise = loadStripe(
  "pk_test_51PdWCeS5Psuwny102zg1w1JVRTrroN6HqsT5R0JPA2eI06hgwIEi6jjlgMpODnSHR1ATwD0rE2VGcihNYmyMUIJE00pDF4GaDv",
);

const StripeDemo = () => {
  const [amount, setAmount] = useState(100); // Default 100 INR
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    try {
      const data: any = await createOneOffCheckoutSession({
        amount: amount,
        userEmail: "demo@example.com",
      });

      const stripe = await stripePromise;

      // Use the ID from the response
      if (data && data.id) {
        const { error } = await stripe!.redirectToCheckout({
          sessionId: data.id,
        });

        if (error) {
          console.error("Stripe Redirect Error:", error.message);
        }
      }
    } catch (err: any) {
      console.error("Backend Error:", err);
      // err will be an instance of your HttpError class
      alert(err.message || "Failed to create session.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>Stripe Demo</h1>
      <div style={{ marginBottom: "20px" }}>
        <label>Enter Amount (INR): </label>
        <input
          type="number"
          value={amount}
          onChange={(e: any) => setAmount(e.target.value)}
          style={{ padding: "8px", marginLeft: "10px" }}
        />
      </div>
      <button
        onClick={handlePay}
        disabled={loading}
        style={{
          padding: "10px 20px",
          backgroundColor: "#6772e5",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {loading ? "Processing..." : "Pay with Stripe"}
      </button>
    </div>
  );
};

export default StripeDemo;
